/**
 * Styles for react-joyride.
 *
 * Important: Joyride (non-legacy) dims the page with overlay + mix-blend-mode: hard-light.
 * The spotlight must use backgroundColor: 'gray' so the blend mode punches a bright hole
 * over the target (content stays full colour). Overriding mixBlendMode to 'normal' or
 * setting spotlight to transparent greys-out the target and only leaves a border.
 */
export const getJoyrideStyles = (
  hideBorder?: boolean,
  hideArrow?: boolean
) => ({
  options: {
    zIndex: 10000,
    arrowColor: hideBorder || hideArrow ? 'transparent' : 'white',
    overlayColor: 'rgba(0, 0, 0, 0.5)',
    // Brand accent used for beacons / default accents
    primaryColor: '#FF6C00',
  },
  spotlight: hideBorder
    ? {
        // Final / non-target steps: no hole ring
        backgroundColor: 'transparent',
        borderWidth: 0,
      }
    : {
        // MUST stay 'gray' for hard-light cut-out (undimmed target like QA)
        backgroundColor: 'gray',
        borderWidth: 4,
        borderRadius: 20,
        // Gold/orange ring matching the QA walkthrough look
        borderColor: '#F5B000',
        borderStyle: 'solid',
      },
});
